<template>
  <div class="unsupported-browser-backdrop">
    <div class="unsupported-browser-modal">
      <div class="d-flex flex-column align-items-center modal-contents">
        <img class="company-logo" :src="$asset(`img/${logoName}.svg`)" :alt="$t('uLekare.title')" />
        <img
          class="disconnected-img"
          :src="$asset('img/disconnected.svg')"
          :alt="$t('unsupportedBrowser.title')"
        />
        <div class="modal-contents__title">
          {{ $t('unsupportedBrowser.title') }}
        </div>
        <div class="modal-contents__perex text-center">
          {{ $t('unsupportedBrowser.perex') }}
        </div>
        <div class="modal-contents__browsers d-flex flex-row justify-content-center">
          <div
            v-for="(browser, key) in browsers"
            :key="key"
            class="browser__container d-flex flex-column align-items-center text-center"
          >
            <button :id="browser.id" class="browser__button">
              <img
                class="browser__logo"
                :src="$asset(`img/logos/${browser.id}_logo.svg`)"
                :alt="browser.name"
              />
            </button>
            <span>{{ browser.id }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsupportedBrowserModal',
  data() {
    return {
      browsers: [
        { name: 'Google Chrome', id: 'chrome' },
        { name: 'Apple Safari', id: 'safari' },
        { name: 'Mozilla Firefox', id: 'firefox' },
        { name: 'Microsoft Edge', id: 'edge' }
      ]
    };
  },
  computed: {
    logoName() {
      return this.$domainRegion === 'sk' ? 'logo-sk' : 'logo';
    }
  }
};
</script>

<style scoped lang="scss">
.unsupported-browser-backdrop {
  display: none;
  position: fixed;
  background-color: white;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999999999;
}

.unsupported-browser-modal {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: white;
  overflow: auto;
  position: relative;
}

.modal-contents {
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  img.company-logo {
    width: 200px;
  }

  img.disconnected-img {
    margin-top: 65px;
    width: 278px;
    height: 88px;
  }

  &__title {
    font-weight: bold;
    margin-top: 70px;
    font-size: 24px;
  }

  &__perex {
    margin-top: 20px;
    max-width: 450px;
    height: 8rem;
  }

  &__browsers {
    margin-top: 70px;
  }

  .browser {
    &__container {
      margin-left: 24px;
      font-weight: 600;

      > span {
        margin-top: 20px;

        &:first-letter {
          text-transform: capitalize;
        }
      }
    }

    &__button {
      background: none;
      border: 3px #dee3e7 solid;
      border-radius: 2rem;
      max-width: 124px;
      padding: 30px;

      &:hover {
        background-color: #dee3e7;
      }
    }

    &__logo {
      width: 60px;
    }
  }
}
</style>
